import { put } from 'redux-saga/effects';

import { actionCreators } from '../../redux';

export function* showAmpCampaigns() {
  yield put(actionCreators.loadAmpCampaigns());
}
